module.exports = __webpack_public_path__ + "img/144.cde3e34b.jpg";